/**
 *
 *
 *
 *
 */

export type * from "../lib/debug/types.js";

export const {
  debug: { activate, logger, deactivate, Level, status },
} = window.o_global;

export type * from "../lib/debug/async.js";
export const { sendLog } = otto.debug;
